export function handleLogout(){
    return {
        type: "LOGOUT",
        payload: {}
    }
}

